import React, { useState, useEffect } from "react";
import { Users, TrendingUp, TrendingDown } from "lucide-react";
import api from "../../../config/api";

const CustomerMetricsCard = () => {
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCustomerData();
  }, []);

  const fetchCustomerData = async () => {
    try {
      const response = await api.get("/admin/dashboard/customers?period=30");
      setCustomerData(response.data.data);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex justify-center items-center h-32">
          <div className="w-6 h-6 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  if (!customerData) return null;

  const isPositive = customerData.summary?.customerGrowth >= 0;
  const growthColor = isPositive ? "text-green-600" : "text-red-600";
  const GrowthIcon = isPositive ? TrendingUp : TrendingDown;

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-purple-500 rounded-md flex items-center justify-center">
            <Users className="w-6 h-6 text-white" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Customers</h3>
            <p className="text-2xl font-semibold text-gray-900">
              {customerData.summary?.totalCustomers || 0}
            </p>
          </div>
        </div>
        <div className={`flex items-center ${growthColor}`}>
          <GrowthIcon className="w-5 h-5 mr-1" />
          <span className="text-sm font-semibold">
            {isPositive ? "+" : ""}
            {customerData.summary?.customerGrowth?.toFixed(1) || 0}%
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-gray-500">New (30d)</p>
          <p className="text-lg font-semibold text-gray-900">
            {customerData.summary?.newCustomers || 0}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Returning</p>
          <p className="text-lg font-semibold text-gray-900">
            {customerData.summary?.returningCustomers || 0}
          </p>
        </div>
      </div>

      <div className="border-t pt-4">
        <div className="flex justify-between items-center">
          <span className="text-xs text-gray-500">Avg Lifetime Value</span>
          <span className="text-sm font-semibold text-gray-900">
            ₹{parseFloat(customerData.summary?.averageLTV || 0).toFixed(2)}
          </span>
        </div>
        <div className="flex justify-between items-center mt-2">
          <span className="text-xs text-gray-500">Retention Rate</span>
          <span className="text-sm font-semibold text-gray-900">
            {parseFloat(customerData.summary?.retentionRate || 0).toFixed(1)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomerMetricsCard;


